import { Row, Col } from 'react-bootstrap'
import ProductContentSection from './product-content-section'

const ProductDescriptionSection = ({ title, content }) => (
  <ProductContentSection title={title}>
    <Row>
      <Col
        sm={10}
        smOffset={1}
        className="lh-lg small"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </Row>
  </ProductContentSection>
)

export default ProductDescriptionSection
